import { navigateToScreen } from 'actionCreators/navigation';
import { ROOT } from 'constants/paths';
import { RETRIEVED_SAVE_APPLICATION } from 'libs/CustomerInformation/src/constants/general';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TimedOutErrorScreen } from './TimedOutErrorScreen';
import { isUserNameAlreadyChoosen } from '../ChooseUserName/ChooseUserNameContainer';

const TimedOutErrorContainer = connect(
  (state, props) => ({
    hasUserNameChosen: state.caseDetails?.caseInfo
      ? isUserNameAlreadyChoosen(state.caseDetails)
      : false,
    onReturnLogin: () => window.location.replace(RETRIEVED_SAVE_APPLICATION),
    clearError: props.clearError
  }),
  (dispatch) =>
    bindActionCreators(
      {
        onReturnHome: () => navigateToScreen(ROOT)
      },
      dispatch
    )
)(TimedOutErrorScreen);
export { TimedOutErrorContainer };
